(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curatory-contact-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curatory-contact-hub')) {
    customElements.define('curatory-contact-hub', class CuratoryContactHub extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.radios = [...this.querySelectorAll('[data-route]')];
        this.panels = [...this.querySelectorAll('[data-route-panel]')];
        this.formLayout = this.querySelector('[data-form-layout]');
        this.announcement = this.querySelector('[data-route-announcement]');
        this.sourceField = this.querySelector('[data-source-field]');
        this.productField = this.querySelector('[data-product-field]');
        if (!this.radios.length || !this.formLayout) return;

        this.formLayout.hidden = true;
        this.panels.forEach((panel) => this.togglePanel(panel, false));
        this.radios.forEach((radio) => radio.addEventListener('change', () => this.selectRoute(radio.dataset.route, true)));

        const params = new URLSearchParams(window.location.search);
        const referrer = document.referrer || '';
        const route = this.normaliseRoute(params.get('reason')) || this.routeFromReferrer(referrer);
        const productContext = params.get('product') || '';
        if (this.sourceField) this.sourceField.value = params.get('source') || referrer || window.location.href;
        if (this.productField) this.productField.value = productContext;
        const productInput = this.querySelector('[name="contact[Product or routine]"]');
        if (productInput && productContext) productInput.value = productContext;
        if (route) {
          const radio = this.radios.find((item) => item.dataset.route === route);
          if (radio) {
            radio.checked = true;
            this.selectRoute(route, false);
          }
        }
      }

      normaliseRoute(value) {
        if (!value) return '';
        const aliases = {
          product: 'product',
          'product-support': 'product',
          routine: 'product',
          skinbetter: 'skinbetter',
          'skinbetter-science': 'skinbetter',
          consultation: 'consultation',
          prescription: 'consultation',
          clinical: 'consultation',
          order: 'order',
          delivery: 'order',
          returns: 'order',
          other: 'other'
        };
        return aliases[value.toLowerCase()] || '';
      }

      routeFromReferrer(referrer) {
        const source = referrer.toLowerCase();
        if (source.includes('skinbetter')) return 'skinbetter';
        if (source.includes('acne-routine') || source.includes('blemish') || source.includes('core-routine')) return 'consultation';
        if (source.includes('/products/')) return 'product';
        return '';
      }

      selectRoute(route, announce) {
        this.panels.forEach((panel) => this.togglePanel(panel, panel.dataset.routePanel === route));
        this.formLayout.hidden = false;
        if (announce && this.announcement) {
          const selected = this.radios.find((radio) => radio.dataset.route === route);
          const label = selected ? this.querySelector(`label[for="${selected.id}"] strong`) : null;
          this.announcement.textContent = label ? `${label.textContent}. ${this.dataset.updateMessage}` : this.dataset.updateMessage;
        }
      }

      togglePanel(panel, active) {
        panel.hidden = !active;
        panel.querySelectorAll('input, select, textarea').forEach((control) => {
          control.disabled = !active;
          control.required = active && control.hasAttribute('data-route-required');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const previewParams = new URLSearchParams(window.location.search);
    const previewThemeId = previewParams.get('preview_theme_id');

    if (!previewThemeId || window.CuratoryPreviewProductLinks) return;

    window.CuratoryPreviewProductLinks = true;

    const preservePreview = (link) => {
      if (!link) return;

      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;

      destination.searchParams.set('preview_theme_id', previewThemeId);

      const previewKey = previewParams.get('key');
      if (previewKey) destination.searchParams.set('key', previewKey);

      link.href = destination.toString();
    };

    const updateLinks = (root = document) => {
      root.querySelectorAll('[data-curatory-preview-product-links] a[data-curatory-product-link]').forEach(preservePreview);
    };

    const initialise = () => updateLinks();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }

    document.addEventListener('shopify:section:load', (event) => updateLinks(event.target));
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-curatory-preview-product-links] a[data-curatory-product-link]');
      preservePreview(link);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
